import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { calculateSessionStatsFromRedux, calculateToolUsagePercentageFromRedux, calculateToolUsagePercentageFromBundles } from '../utils/analyticsUtilsBackend';

export function useDashboardKPIsBackend(selectedPeriod = '7 derniers jours', selectedSpace = 'personal', email = '') {
  const { allSessions, allEvents, sessionToolBundles } = useSelector(s => s.sessions || { allSessions: [], allEvents: [], sessionToolBundles: [] });
  const [sessionStats, setSessionStats] = useState(null);
  const [toolUsageStats, setToolUsageStats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const calculateKPIs = () => {
    try {
      setLoading(true);
      const stats = calculateSessionStatsFromRedux(allSessions, selectedPeriod, email);
      setSessionStats(stats);

      // Prefer bundles (robust against backend empties); fallback to events
      let toolStats = calculateToolUsagePercentageFromBundles(sessionToolBundles, selectedSpace, selectedPeriod, email);
      if (!toolStats || toolStats.length === 0) {
        toolStats = calculateToolUsagePercentageFromRedux(allEvents, selectedSpace, selectedPeriod, email);
      }
      setToolUsageStats(toolStats);

      setError(null);
    } catch (err) {
      setError(err.message);
      console.error('Error calculating backend session stats:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    calculateKPIs();
  }, [selectedPeriod, selectedSpace, email, allSessions, allEvents, sessionToolBundles]);

  return {
    sessionStats,
    toolUsageStats,
    loading,
    error,
    refreshKPIs: calculateKPIs,
  };
}
